import React, { useState } from "react";
import "./GaleriePhotos.css";
import chantier1 from '../assets/photos/chantier-trh1.jpg';
import chantier2 from '../assets/photos/chantier-trh2.jpg';
import chantier21 from '../assets/photos/chantier-trh21.jpg';
import chantier22 from '../assets/photos/chantier-trh22.jpg';
import chantier3 from '../assets/photos/chantier-trh3.jpg';
import chantier4 from '../assets/photos/chantier-trh4.jpg';
import chantier41 from '../assets/photos/chantier-trh41.jpg';
import chantier5 from '../assets/photos/chantier-trh5.jpg';
import chantier6 from '../assets/photos/chantier-trh6.jpg';
import chantier7 from '../assets/photos/chantier-trh7.jpg';

const GaleriePhotos = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
  
    const openModal = (image) => {
      setSelectedImage(image);
      setIsModalOpen(true);
    };
  
    const closeModal = () => {
      setIsModalOpen(false);
      setSelectedImage('');
    };


  return (
    <>
    <section id="realisations" className="section fade-in">
    <div className="sectionContent">
    <h2>Quelques réalisations </h2>

        <div className="gallery">
        <img src={chantier1} alt="Réalisation 1" onClick={() => openModal(chantier1)} />
        <img src={chantier2} alt="Réalisation 2" onClick={() => openModal(chantier2)} />
        <img src={chantier21} alt="Réalisation 3" onClick={() => openModal(chantier21)} />
        <img src={chantier22} alt="Réalisation 4" onClick={() => openModal(chantier22)} />
        <img src={chantier3} alt="Réalisation 5" onClick={() => openModal(chantier3)} />
        <img src={chantier4} alt="Réalisation 6" onClick={() => openModal(chantier4)} />
        <img src={chantier41} alt="Réalisation 7" onClick={() => openModal(chantier41)} />
        <img src={chantier5} alt="Réalisation 8" onClick={() => openModal(chantier5)} />
        <img src={chantier6} alt="Réalisation 9" onClick={() => openModal(chantier6)} />
        <img src={chantier7} alt="Réalisation 10" onClick={() => openModal(chantier7)} />
        </div>
        </div>
    </section>

          {/* Modal pour afficher l'image en grand */}
          {isModalOpen && (
            <div className="modal fade-in" onClick={closeModal}>
              <span className="close">&times;</span>
              <img className="modal-content" src={selectedImage} alt="Image agrandie" />
            </div>
          )}
    
          </>
  );
};

export default GaleriePhotos;




